// src/shared/components/Alert/index.js
import React from 'react';
import { Alert as BootstrapAlert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Alert = ({
    show,
    variant,
    message,
    onClose,
    dismissible = true,
    timeout = 10000
}) => {
    React.useEffect(() => {
        if (show && dismissible && timeout) {
            const timer = setTimeout(() => {
                onClose();
            }, timeout);
            return () => clearTimeout(timer);
        }
    }, [show, dismissible, timeout, onClose]);

    if (!show) return null;

    return (
        <BootstrapAlert
            variant={variant}
            onClose={onClose}
            dismissible={dismissible}
        >
            {message}
        </BootstrapAlert>
    );
};

Alert.propTypes = {
    show: PropTypes.bool.isRequired,
    variant: PropTypes.oneOf([
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
        'light',
        'dark'
    ]).isRequired,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    dismissible: PropTypes.bool,
    timeout: PropTypes.number
};

export default Alert;